module.exports = require("npm:object-fit-images@3.2.3/dist/ofi.common-js.js");